var render = function () {
  var _vm$attrib, _vm$attrib2, _vm$attrib2$field;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-compare__title"
  }, [_vm.attrib.label ? _c('span', {
    staticClass: "mb-1"
  }, [_vm._v(" " + _vm._s(_vm.attrib.label) + " ")]) : _vm._e(), _vm.attrib.icon ? _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.attrib.icon
    }
  }) : _vm._e(), (_vm$attrib = _vm.attrib) !== null && _vm$attrib !== void 0 && _vm$attrib.img || (_vm$attrib2 = _vm.attrib) !== null && _vm$attrib2 !== void 0 && (_vm$attrib2$field = _vm$attrib2.field) !== null && _vm$attrib2$field !== void 0 && _vm$attrib2$field.img ? _c('b-img', {
    attrs: {
      "src": _vm.imgPath + _vm.attrib.field.img,
      "fluid": ""
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }